import KinglyLogo from "@/components/KinglyLogo";

/** Shown for the split second while a lazily-loaded page chunk downloads. */
export default function PageFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="page-loading">
      <div className="flex flex-col items-center gap-3 animate-pulse">
        <KinglyLogo size={44} />
        <span className="text-xs uppercase tracking-[0.25em] text-slate-400 font-semibold">Loading</span>
      </div>
    </div>
  );
}
